import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ComponentStatusDiv = ({equipment, equipmentComponents, componentId, equipmentPartsByComponentId, target="default"}) => {
    const { t } = useTranslation();
    const [isPannelView, setIsPannelView] = useState(false);
    const [pannelBgColor, setPannelBgColor] = useState('#000');

    useEffect(()=>{
        // if (equipment?.equipmentCtgr?.parent?.parent?.code === 'EV' || equipment?.equipmentCtgr?.parent?.parent?.code === 'ES') {
        if (equipment?.latestEquipmentOp) {
            setIsPannelView(true);
            if (equipment?.latestEquipmentOp?.controlPanelCode?.alertYn === 'Y') {
                if (componentId===-1)
                    setPannelBgColor('#ed1c24');
                else
                    setPannelBgColor('#000');
            } else {
                if (componentId===-1)
                    setPannelBgColor('#0061d0');
                else
                    setPannelBgColor('#000');
            }
        }
    },[isPannelView, componentId])
    
    return (
        <div style={{padding:"0 20px"}}>
        {isPannelView && 
            <p className="statustab1" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`3px solid ${pannelBgColor}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{equipmentPartsByComponentId(-1)}}>{t('message.common.chip.panel')}</p>
        }
        {equipmentComponents && equipmentComponents.map(function(item, i) {
            let componentName = item.name;
            let bgColor = "#0061d0";
            // if (target === 'default' && item.sensorYn) {
            // if (target === 'maintenance' || target === 'default') {
                if (item.countFaultCodesOfAlertY && item.countFaultCodesOfAlertY > 0) {
                    bgColor = "#ed1c24";
                } else if (item.countFaultCodesOfAlertN && item.countFaultCodesOfAlertN > 0) {
                    bgColor = "#e5a846";
                } else {
                    bgColor = "#0061d0";
                }

                if (item.status === 'NORMAL') {
                    componentName += '<span class="instate1">'+t('message.common.text.available')+'</span>';//유효
                    // bgColor = "#5b9bd5";
                } else if (item.status === 'ALERT') {
                    componentName += '<span class="instate2">'+t('message.common.text.imminent')+'</span>';//임박
                    // bgColor = "#ff0000";
                } else if (item.status === 'EXPIRED') {
                    componentName += '<span class="instate3">'+t('message.common.text.lapse')+'</span>';//경과
                    // bgColor = "#2c2c2c";
                }
           
                if (componentId === item.id) {
                    return (
        <p className="statustab2" key={i} style={{cursor:"pointer", display:"inline-block", padding:"3px 5px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`3px solid ${bgColor}`, backgroundColor:"#000", color:"#fff"}} onClick={()=>{equipmentPartsByComponentId(item.id)}} dangerouslySetInnerHTML={ {__html: componentName} }></p>
                    )
                } else {
                    return (
        <p className="statustab3" key={i} style={{cursor:"pointer", display:"inline-block", padding:"3px 5px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`2px solid #000`, backgroundColor:"#000", color:"#fff"}} onClick={()=>{equipmentPartsByComponentId(item.id)}} dangerouslySetInnerHTML={ {__html: componentName} }></p>
                    )
                }
            // }
        }) }
        </div>
    )
}

export default ComponentStatusDiv;